export default __webpack_public_path__ + "static/media/bannerDexco.b03c77b2.jpg";